import React, { useState } from "react";
import KickImage from 'Reuseables/KickImage';

import { Col } from "react-bootstrap"

/* UTILS / HELPERS */
import { getCloudImageUrl, convertToRupiah } from "../../../../utils"

/* COMPONENTS */
import SwitchToggle from "./SwitchToggle"
import UserBalanceInfoModal from "./UserBalanceInfoModal"
import InfoInsuficientBalance from "./InfoInsuficientBalance"
import { ShippingNReturnPolicy } from "../../../Modals/StaticInfoModal/ModalStaticInfo";

/* ASSETS */
import WarningSign from "../../../../images/warning-orange.png";
import BackArrow from "../../../../images/shopping-cart-back.png";
import ContinueArrow from "../../../../images/shopping-cart-continue.png";
import InfoCredit from "../../../../images/info-kredit.png";

const WarningSignIcon: any = WarningSign
const BackArrowIcon: any = BackArrow
const ContinueArrowIcon: any = ContinueArrow
const InfoCreditIcon: any = InfoCredit


interface paymentMethod {
  type: string;
  logo: string;
  label: string;
  active: boolean;
  payment_group: number;
  payment_method: string;
}

interface kredivoInstallment {
  label: string
  monthly_installment: number
  value: string
}

interface availableMethod {
  type: string;
  logo: string;
  label: string;
  active: boolean;
  payment_group: number;
  payment_method: string;
}

interface balanceUsage {
  kickPoint: 0,
  kickCredit: 0,
  sellerCredit: 0,
  remainingPayment: 0,
}


interface balanceUsage {
  kickPoint: 0,
  kickCredit: 0,
  sellerCredit: 0,
  remainingPayment: 0,
}

interface paymentMethod {
  type: string;
  logo: string;
  label: string;
  active: boolean;
  payment_group: number;
  payment_method: string;
}

interface kredivoInstallment {
  label: string
  monthly_installment: number
  value: string
}

interface currencyType {
  currency: string;
  isFetch: boolean; 
  ratio: number;
}

type KickCreditProcessProps = {
  isSubmit: boolean
  balance: string
  dataAkulaku: Array<Object>
  isIndonesian: boolean
  isResponsive: boolean
  balanceUsage: balanceUsage
  amountToBePaid: string
  locked_balance: string
  isSplitPayment: boolean
  balance_with_fee: string
  _installmentsList: Array<kredivoInstallment>
  kickCreditProcess: string
  isKickPointActive: boolean
  isKickCreditActive: boolean
  currentPaymentMethod: paymentMethod
  isOpenModalBalanceInfo: boolean
  isOpenInsuficientBalance: boolean
  selectedSplitPaymentMethod: paymentMethod | null
  selectedSplitKredivoInstallment: kredivoInstallment | null,
  userCurrency: currencyType
  handleSubmit: () => void
  handleUsageBalance: (wallet_type: string, args: boolean) => void
  setMakeOfferProcess: (args: string) => void
  setIsKickPointActive: (args: boolean) => void
  setIsModalBalanceInfo: (args: boolean) => void
  setCurrentPaymentMethod: (args: Object) => void
  setSelectedSplitPaymentMethod: (args: paymentMethod | kredivoInstallment | null) => void
  handleFetchKredivoInstallments: () => void
  setSelectedSplitKredivoInstallment: (item: kredivoInstallment | null) => void
  setIsKickCreditActive: (args: boolean) => void
  setIsOpenInsuficientBalance: (args: boolean) => void
}

const KickCreditProcess: React.FC<KickCreditProcessProps> = ({
  isSubmit,
  balance,
  balanceUsage,
  isResponsive,
  isSplitPayment,
  amountToBePaid,
  locked_balance,
  balance_with_fee,
  isKickPointActive,
  currentPaymentMethod,
  isOpenModalBalanceInfo,
  isOpenInsuficientBalance,
  selectedSplitPaymentMethod,
  isKickCreditActive,
  setIsOpenInsuficientBalance,
  handleSubmit,
  setMakeOfferProcess,
  handleUsageBalance,
  setIsKickPointActive,
  setIsModalBalanceInfo,
  setCurrentPaymentMethod,
  setIsKickCreditActive,
  userCurrency
}): JSX.Element => {
  const [openShippingPolicyInfo, setOpenShippingPolicyInfo] = useState(false)
  const disabled = (() => {
    if (!selectedSplitPaymentMethod) {
      if (balanceUsage.remainingPayment > 0) return true
      return false
    }
    if (isSubmit) return true
    return false
  })();

  const disableToggleButton = ((money, isActive) => {
    if (money === 0) return true
    if (!isActive && balanceUsage.remainingPayment === 0) return true
    return false
  })
  const totalBalance = parseInt(balance) + parseInt(balance_with_fee)
  const isOpenInfoInsuficientBalance = balanceUsage.remainingPayment > 0 && (isKickCreditActive || totalBalance === 0)
  const isOnlyKickPoint = userCurrency?.currency === "KP"

  return (
    <Col className="kick-credit-process-wrapper">
      <div className="content-wrapper">
        {isResponsive && <div className="amount-to-be-paid">
          <p>Amount to be paid</p>
          <p>IDR {convertToRupiah(parseInt(amountToBePaid))}</p>
        </div>
        }
        <div className="kick-credit-card-container">
          <p>Payment method</p>
          <div className="payment-method-card">
            <div
              className="balance-info-icon-wrapper"
              onClick={() =>
                setIsModalBalanceInfo(!isOpenModalBalanceInfo)
              }
            >
              <KickImage src={InfoCreditIcon} />
            </div>
            <KickImage
              src={getCloudImageUrl(currentPaymentMethod.logo)}
              alt="..."
            />
            <div className="payment-method-currency">
              {currentPaymentMethod.label === "Full Wallet" && (
                <>
                  <p>
                    Credit Balance: IDR. <span>{convertToRupiah(parseInt(balance) + parseInt(balance_with_fee))}</span>
                  </p>
                  <p>
                    Kick Points: IDR. <span>{convertToRupiah(parseInt(locked_balance))}</span>
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="kick-points-container">
          <div className={`points-wrapper ${disableToggleButton(parseInt(balance) + parseInt(balance_with_fee), isKickCreditActive) || isOnlyKickPoint? "disabled" : ""}`}>
            <p>Use Credit</p>
            {/* <p>Balance: IDR. {convertToRupiah(parseInt(locked_balance))}</p> */}
            <p>Credit Balance: IDR. <span>{convertToRupiah(parseInt(balance) + parseInt(balance_with_fee))}</span></p>
          </div>
          <SwitchToggle
            disabled={disableToggleButton(parseInt(balance) + parseInt(balance_with_fee), isKickCreditActive) || isOnlyKickPoint}
            isKickPointActive={isKickCreditActive}
            handleToggleKickPoint={() => {
              setIsKickCreditActive(!isKickCreditActive);
              handleUsageBalance("kick_credits", !isKickCreditActive);
            }}
          />
        </div>
        <div className="kick-points-container">
          <div className={`points-wrapper ${disableToggleButton(parseInt(locked_balance), isKickPointActive) ? "disabled" : ""}`}>
            <p>Use Kick Point</p>
            <p>Balance: IDR. {convertToRupiah(parseInt(locked_balance))}</p>
          </div>
          <SwitchToggle
            disabled={disableToggleButton(parseInt(locked_balance), isKickPointActive)}
            isKickPointActive={isKickPointActive}
            handleToggleKickPoint={() => {
              setIsKickPointActive(!isKickPointActive);
              handleUsageBalance("kick_points", !isKickPointActive);
            }}
          />
        </div>
        {
          isOpenInfoInsuficientBalance && <InfoInsuficientBalance
            remainingPayment={balanceUsage.remainingPayment}
          />
        }
        <div className="kick-credit-payment-summary">
          <div className="summary-detail">
            <p>Amount to be paid</p>
            <p>IDR {convertToRupiah(parseInt(amountToBePaid))}</p>
          </div>
          {balanceUsage.kickCredit > 0 && <div className="summary-detail">
            <p>Kick credit usage</p>
            <p>IDR {convertToRupiah(balanceUsage.kickCredit)}</p>
          </div>}
          {balanceUsage.sellerCredit > 0 && <div className="summary-detail">
            <p>Seller credit usage</p>
            <p>IDR {convertToRupiah(balanceUsage.sellerCredit)}</p>
          </div>}
          {balanceUsage.kickPoint > 0 && <div className="summary-detail">
            <p>Kick points usage</p>
            <p>IDR {convertToRupiah(balanceUsage.kickPoint)}</p>
          </div>}
          <div className="summary-detail">
            <p>Remaining Payment</p>
            <p>
              IDR. {convertToRupiah(balanceUsage.remainingPayment)}
            </p>
          </div>
        </div>
      </div>
      <div className="kick-credit-button">
        <p>By clicking Proceed to payment, you have agreed on our <u onClick={() => setOpenShippingPolicyInfo(!openShippingPolicyInfo)}>Shipping and Returns Policy</u> and our Terms and Conditions.
          {`${selectedSplitPaymentMethod && selectedSplitPaymentMethod.type !== "bank_transfer" && "You will be redirected to payment page provided by a secured 3rd party."}`}
        </p>
        <div
          onClick={() => {
            setMakeOfferProcess("choose-payment");
            setCurrentPaymentMethod({});
          }}
          className="button button-22"
        >
          <KickImage src={BackArrowIcon} alt="..." />
          <p>Back</p>
        </div>
        <div
          className={`button button-21 ${disabled
            ? "disabled"
            : ""
            }`}
          onClick={() => !disabled && handleSubmit()}
        >
          <p>Proceed to Payment</p>
          <KickImage src={ContinueArrowIcon} alt="..." />
        </div>
      </div>
      <UserBalanceInfoModal
        isOpenModalInfo={isOpenModalBalanceInfo}
        onToggle={() =>
          setIsModalBalanceInfo(!isOpenModalBalanceInfo)
        }
      />
      <ShippingNReturnPolicy isOpen={openShippingPolicyInfo} onToggle={() => setOpenShippingPolicyInfo(!openShippingPolicyInfo)} />
    </Col>
  )
}

export default KickCreditProcess